import axios from "axios"
import { env } from '../constants'


/* The token of the administrator goes with every call */
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } })


/* LIST — the codes with the filters, the numbers of the log, the days and the phones which ask too often */
export const list = data => {
    const uri = `${env.startpoint}/admin/otp/list`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}
